import defaultAvatar from '../styles/images/account.svg';
import React from 'react';

const LoginAvatarScreen = (user) => {
    return (
        <div className='avatar'>
            <img src={user.user.photoURL || defaultAvatar} alt=''/>
        </div>
    )
};

export default LoginAvatarScreen;


// WEBPACK FOOTER //
// ./src/screens/LoginAvatarScreen.js